import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'store/index' ///导入公共仓库

Vue.use(VueRouter)

///路由文件的导入
import routes from 'router/mainroutes'

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  ///服务端默认的根路径文件夹配置
  // 这里的base很重要，这里base的名称是放在tomcat的webapps下的文件
  // base: '/smart-web/', /////没什么用,用上面的环境变量就行
  routes
})

/**
 * 重写路由的push方法,,解决路由重复报错的问题
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

/**
 * 重写路由的Replace方法,,解决路由重复报错的问题
 */
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}

//全局导航守卫 前置守卫
router.beforeEach((to, from, next) => {
  console.log('全局导航守卫')
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限

    console.log(store.getters)
    console.log(store)
    console.log(sessionStorage.getItem('token'))

    if (sessionStorage.getItem('token')) {
      // 通过vuex state获取当前的token是否存在
      console.log('经过全局导航守卫')
      
      next()
    } else {
      console.log('路由跳转的守卫拦截')
      console.log(to.fullPath)
      next({
        path: '',
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    console.log('经过全局导航守卫')

    next()
  }
})

export default router
